// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__Lc3Ol","img":"Arrow_img__31eNO","left":"Arrow_left__1r5Su","right":"Arrow_right__3SxLF","show":"Arrow_show__2YdP5","hide":"Arrow_hide__nsQOx"};